export const getName = (user) => {
  if (user) {
    if (user.profile && user.profile.name) return user.profile.name;
    if (user.email) return user.email;
  }
};
